import { memo, useCallback } from 'react'

import { Divider, SvgIcon } from '@mui/material'
import { OrgEnvironmentRoleRamMember } from '@nativewaves/nw-cloud-sdk/org'
import { PlugDisconnected } from 'emotion-icons/fluentui-system-filled'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { MenuItemConfirm, MenuItemCopyId } from '@shared/components/MaterialUIEnhancements/Menu/MenuItem'
import { RowActionsProps } from '@shared/components/Table'
import { useEnvironmentMemberDeleteMutation } from 'hooks/mutations/org'
import { environmentRoute } from 'pages/NWPlatform'
import { resolveDisplayName } from 'utils/userInfo'

const RowActionsRaw = ({ row, onClose }: RowActionsProps<OrgEnvironmentRoleRamMember>) => {
  const { t } = useTranslation(['common', 'domain', 'entity'])
  const { enqueueSnackbar } = useSnackbar()

  const { environmentId } = environmentRoute.useParams()

  const { id, teamInfo, userInfo } = row.original

  const { mutate: deleteMember } = useEnvironmentMemberDeleteMutation()

  const handleDeleteAvcTask = useCallback(() => {
    onClose()

    deleteMember(
      { environmentId, memberId: id },
      {
        onError: () =>
          enqueueSnackbar(
            t('domain:EnvironmentSetting.nameDelete', { name: resolveDisplayName(userInfo) || teamInfo?.name }),
            {
              variant: 'error',
            },
          ),
      },
    )
  }, [onClose, deleteMember, environmentId, id, enqueueSnackbar, t, userInfo, teamInfo?.name])

  return (
    <>
      <MenuItemCopyId onSuccess={onClose} id={id} />
      <Divider sx={{ my: 1 }} component="li" />
      <MenuItemConfirm
        onConfirm={handleDeleteAvcTask}
        staticLabel={t('domain:EnvironmentSetting.removeMember')}
        startIcon={
          <SvgIcon color="error">
            <PlugDisconnected />
          </SvgIcon>
        }
        ConfirmTypographyProps={{ color: 'error' }}
      />
    </>
  )
}

export const RowActions = memo(RowActionsRaw)
